import Vue from 'vue';
import { Backend } from '@/_axios';

// import mutations from './mutations'
// import actions from './actions'
// import moment from 'moment';

export const LOAD_JIRA_USERS = 'LOAD_JIRA_USERS';
export const SET_JIRA_USERS = 'SET_JIRA_USERS';

export const SAVE_JIRA_USER = 'SAVE_JIRA_USER';
export const SET_JIRA_USER = 'SET_JIRA_USER';

export const LOAD_JIRA_ACTIVE_USERS = 'LOAD_JIRA_ACTIVE_USERS';
export const SET_JIRA_ACTIVE_USERS = 'SET_JIRA_ACTIVE_USERS';

export const SAVE_EXISTING_JIRA_USER = 'SAVE_EXISTING_JIRA_USER';
export const SET_SAVED_EXISTING_JIRA_USER = 'SET_SAVED_EXISTING_JIRA_USER';
export const SET_SAVED_EXISTING_JIRA_USER_ERROR = 'SET_SAVED_EXISTING_JIRA_USER_ERROR';

export const SAVE_VACATION_BALANCE = 'SAVE_VACATION_BALANCE';
export const SET_JIRA_ACTIVE_USER = 'SET_JIRA_ACTIVE_USER';
export const SET_SAVED_EXISTING_JIRA_USER_VACATION = 'SET_SAVED_EXISTING_JIRA_USER_VACATION';

const state = {
  users: {},
  activeUsers: {},
  jiraUserUpdateNotification: {
    status: 'loading',
    data: {},
    message: ''
  },
  jiraUserVacationUpdateNotification: {
    status: 'loading',
    data: {},
    message: ''
  }
};

const getters = {
  users: (state) => {
    return state.users;
  },
  activeUsers: (state) => {
    return state.activeUsers;
  },
  jiraUserUpdateNotification: (state) => {
    return state.jiraUserUpdateNotification;
  },
  jiraUserVacationUpdateNotification: (state) => {
    return state.jiraUserVacationUpdateNotification;
  }
};

const actions = {
  [LOAD_JIRA_USERS]: function ({ commit }) {
    Backend.get('/api/all-jira-users').then((response) => {
      const users = {};
      response.data.forEach((user) => {
        users[user.id] = user;
      });
      commit('SET_JIRA_USERS', { users: users });
    });
  },
  [SAVE_JIRA_USER]: function ({ commit }, user) {
    Backend.post('/api/save-jira-user', { user: user }).then((response) => {
      commit('SET_JIRA_USER', response.data);
    });
  },
  [LOAD_JIRA_ACTIVE_USERS]: function ({ commit }) {
    Backend.get('/api/jira-active-users').then((response) => {
      const activeUsers = {};
      response.data.forEach((user) => {
        activeUsers[user.id] = user;
      });
      commit('SET_JIRA_ACTIVE_USERS', activeUsers);
    }, (err) => {
      // console.log(err.response);
    });
  },
  [SAVE_EXISTING_JIRA_USER]: function ({ commit }, user) {
    Backend.post('/api/save-existing-jira-user', { user: user }).then((response) => {
      commit('SET_SAVED_EXISTING_JIRA_USER', { user: response.data.data.data, message: response.data.data.message });
    }, (err) => {
      console.log(err.response);
      commit('SET_SAVED_EXISTING_JIRA_USER_ERROR', err.response.data.data.message);
    });
  },
  [SAVE_VACATION_BALANCE]: function ({ commit }, { startBalance, dateOfRecruitment, userId }) {
    Backend.post('/api/save-jira-user-vacation-balance', { start_vacation_balance: startBalance, recruitment_date: dateOfRecruitment, jira_user_id: userId }).then((response) => {
      commit('SET_SAVED_EXISTING_JIRA_USER_VACATION', { user: response.data.data, message: response.data.message });
    });
  }
};

const mutations = {
  [SET_JIRA_USERS]: function (state, { users }) {
    state.users = users;
  },
  [SET_JIRA_USER]: function (state, user) {
    Vue.set(state.users, user.id, user);
  },
  [SET_JIRA_ACTIVE_USERS]: function (state, users) {
    Vue.set(state, 'activeUsers', users);
  },
  [SET_SAVED_EXISTING_JIRA_USER]: function (state, { user, message }) {
    state.jiraUserUpdateNotification = {
      status: 'success',
      data: user,
      message: message
    };
    Vue.set(state.users, user.id, user);
  },
  [SET_SAVED_EXISTING_JIRA_USER_VACATION]: function (state, { user, message }) {
    if (user.vacation_balance) {
      user.vacation_balance = parseFloat(user.vacation_balance).toFixed(1);
    } else {
      user.vacation_balance = 0.0;
    }
    if (user.start_vacation_balance) {
      user.start_vacation_balance = parseFloat(user.start_vacation_balance).toFixed(1);
    } else {
      user.start_vacation_balance = 0.0;
    }
    state.jiraUserVacationUpdateNotification = {
      status: 'success',
      data: user,
      message: message
    };
    Vue.set(state.activeUsers, user.id, user);
  },
  [SET_SAVED_EXISTING_JIRA_USER_ERROR]: function (state, message) {
    state.jiraUserUpdateNotification = {
      status: 'error',
      data: {},
      message: message
    };
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
